export {
    type HistoryService,
    type HistoryInterval,
    totalTimeForInterval,
    intervalForExpectedMaxCount,
} from './history.service'
export { HistoryModule } from './history.module'
